<template>
  <div class="carousel-container">
    <el-carousel :interval="4000" height="500px" arrow="always">
      <el-carousel-item v-for="(item, index) in carouselItems" :key="index">
        <div class="image-wrapper">
          <el-image :src="item.imgUrl" class="carousel-image">
            <div slot="placeholder" class="image-slot">
              加载中<span class="dot">...</span>
            </div>
          </el-image>
        </div>
        <div class="carousel-caption">
          <h3>{{ item.title }}</h3>
          <p>{{ item.description }}</p>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  name: "PageMid",
  data() {
    return {
      carouselItems: [
        {
          imgUrl: require("../assets/banner1(1).jpg"),
          title: "",
          description: "",
        },
        {
          imgUrl: require("../assets/banner2.jpg"),
          title: "",
          description: "",
        },
        {
          imgUrl: require("../assets/banner3.jpg"),
          title: "",
          description: "",
        },
      ],
    };
  },
};
</script>

<style scoped>
.carousel-container {
  width: 100%;
  height: 500px;
  position: relative;
  overflow: hidden;
}

.image-wrapper {
  width: 100%;
  height: 500px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  background: #000;
}
::v-deep .el-image__inner {
  object-fit: cover;
}
.carousel-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  transition: transform 0.5s ease;
}

.carousel-image:hover {
  transform: scale(1.05);
}

.carousel-caption {
  display: none;
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  color: #fff;
  background: rgba(0, 0, 0, 0.5);
  padding: 10px 20px;
  border-radius: 4px;
}

.carousel-caption h3 {
  font-size: 24px;
  margin: 0 0 8px 0;
}

.carousel-caption p {
  font-size: 16px;
  margin: 0;
}

/* 响应式处理 */
@media (max-width: 768px) {
  .carousel-container {
    height: 200px !important;
  }

  .image-wrapper {
    height: 200px;
  }

  .carousel-caption {
    bottom: 10px;
    padding: 5px 10px;
  }

  .carousel-caption h3 {
    font-size: 18px;
  }

  .carousel-caption p {
    font-size: 12px;
  }
}
</style>
